import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import CreatePlayer from 'modules/teams/ui/components/form-parts/players/create-player';
import { useCallback, useState } from 'react';
import Modal from 'ud-ui/components/modal';
import UDText from 'ud-ui/components/text';

interface UseModalCreatePlayerProps {
  teamId: number;
  /** Весь состав команды — нужен `CreatePlayer` для проверки дублей. */
  players: TeamPlayer[];
}

/**
 * Модалка с той же формой, что на `/players/create` — открывается поверх карточки
 * заявок команды, чтобы завести нового игрока и сразу заявить его в текущую команду,
 * не покидая экран.
 */
function useModalCreatePlayer({ teamId, players }: UseModalCreatePlayerProps) {
  const { info } = useOrganizer();
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const modal = (
    <Modal show={isOpen} onClose={close} size="lg">
      <UDText type="title-3" className="mb-6">
        Новый игрок
      </UDText>
      {info && <CreatePlayer tournamentId={info.id} teamId={teamId} players={players} onSuccess={close} onCancel={close} />}
    </Modal>
  );

  return { open, Modal: modal };
}

export default useModalCreatePlayer;
